/* eslint-disable no-unused-vars */
import * as S from './WelcomeManageApps.styled';
import { AddNewAppBtn } from 'components';
import { ManageAppsWelcome, ManageAppsWelcomeAdvertiser } from 'assets/icons';

export const WelcomeManageApps = ({ isAdvertiser }) => {
  const WelcomeIcon = isAdvertiser ? ManageAppsWelcomeAdvertiser : ManageAppsWelcome;

  return (
    <S.Container>
      <S.Title>Welcome</S.Title>
      <S.Text>
        Get started by adding your first application. We&apos;ll walk you through the process, and
        <br />
        you&apos;ll have all the settings you need to reach success.
      </S.Text>
      <AddNewAppBtn.ManageAppsPage />
      <WelcomeIcon />
    </S.Container>
  );
};
